import type { GeocodingStatus } from "~domain/addresses/models/address-model.ts";
import type { SITE_ADDRESS_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-address/site-address.fr.ts";

const status: Record<GeocodingStatus, string> = {
  GEOCODED: "Geocoded address",
  NEARBY: "Nearby address",
  NON_GEOCODED: "Partial address",
};

export const SITE_ADDRESS_ENGLISH_LOCALE = {
  provider: {
    google: "Google address",
    gouvfr: "French government address",
  },
  status: status,
} satisfies typeof SITE_ADDRESS_FRENCH_LOCALE;
